// Module
var code = " <div class=\"betreuung-mitteilung-view gesuch-modul static-position\"> <div class=\"row view-title\"> <div class=\"col-md-12\"> <form role=\"form\" name=\"vm.form\" class=\"\" novalidate unsaved-warning-form> <dv-mitteilung-list form=\"vm.form\"></dv-mitteilung-list> </form> </div> </div> </div> ";
// Exports
module.exports = code;